import React from "react";
import { useSelector } from "react-redux";
import Support from "logistic-integrations/components/Support";
import { useTranslation } from "react-i18next";

function SliderSupport() {
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);
  const { t } = useTranslation();
  return (
    <Support
      orderNo={
        orderInfo?.logisticPartnerMetadata?.SLIDER?.createDeliveryResponse
          ?.order_number
      }
      phone={process.env.REACT_APP_SUPPORT_MOBILE}
      heading={t("Slider Order Number")}
      heading2={t("Slider Helpline Number")}
    />
  );
}

export default SliderSupport;
